/**
 * Style Shopify's native cookie banner like a readable bottom bar:
 * left = title + full text, right = Manage / Decline / Accept.
 * No max-height clipping. Chat + Qikify stay above.
 */
(function () {
  var STYLE_ID = 'amizek-cookie-force-style';

  var CSS = [
    '#shopify-pc__banner,',
    '#shopify-pc__banner.shopify-pc__banner,',
    '.shopify-pc__banner{',
    'position:fixed!important;top:auto!important;left:0!important;right:0!important;bottom:0!important;',
    'width:100%!important;max-width:100vw!important;height:auto!important;max-height:none!important;',
    'margin:0!important;padding:0!important;transform:none!important;z-index:99990!important;',
    'background:#ffffff!important;background-color:#ffffff!important;opacity:1!important;',
    'box-shadow:0 -4px 18px rgba(0,0,0,.16)!important;border-top:1px solid #cfcfcf!important;',
    'overflow:visible!important;pointer-events:auto!important;color:#111111!important;',
    '}',
    '#shopify-pc__banner .shopify-pc__banner__dialog,',
    '.shopify-pc__banner__dialog{',
    'position:relative!important;top:auto!important;left:auto!important;right:auto!important;bottom:auto!important;',
    'width:100%!important;max-width:100%!important;min-width:0!important;height:auto!important;max-height:none!important;',
    'margin:0!important;padding:0!important;transform:none!important;border-radius:0!important;',
    'background:#ffffff!important;background-color:#ffffff!important;opacity:1!important;',
    'overflow:visible!important;pointer-events:auto!important;color:#111111!important;box-shadow:none!important;',
    '}',
    '#shopify-pc__banner .shopify-pc__banner__wrapper,',
    '.shopify-pc__banner__wrapper{',
    'display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:center!important;',
    'justify-content:space-between!important;gap:12px 20px!important;width:100%!important;max-width:1100px!important;',
    'margin:0 auto!important;padding:14px 16px calc(14px + env(safe-area-inset-bottom,0px))!important;',
    'box-sizing:border-box!important;background:#ffffff!important;opacity:1!important;color:#111111!important;',
    'height:auto!important;max-height:none!important;overflow:visible!important;',
    '}',
    '#shopify-pc__banner .shopify-pc__banner__body,',
    '.shopify-pc__banner__body{',
    'flex:1 1 auto!important;min-width:0!important;max-width:none!important;width:auto!important;margin:0!important;',
    'color:#111111!important;opacity:1!important;visibility:visible!important;overflow:visible!important;',
    'max-height:none!important;display:block!important;',
    '}',
    '#shopify-pc__banner .shopify-pc__banner__body-title,',
    '.shopify-pc__banner__body-title{',
    'display:block!important;margin:0 0 4px!important;font-size:16px!important;font-weight:700!important;',
    'line-height:1.3!important;color:#111111!important;opacity:1!important;visibility:visible!important;',
    '}',
    '#shopify-pc__banner .shopify-pc__banner__body p,',
    '.shopify-pc__banner__body p,',
    '#shopify-pc__banner .shopify-pc__banner__body span,',
    '.shopify-pc__banner__body span{',
    'display:inline!important;margin:0!important;font-size:14px!important;line-height:1.4!important;',
    'color:#111111!important;opacity:1!important;visibility:visible!important;',
    'white-space:normal!important;overflow:visible!important;max-height:none!important;',
    '-webkit-line-clamp:unset!important;line-clamp:unset!important;',
    '}',
    '#shopify-pc__banner .shopify-pc__banner__body p{display:block!important;margin:0 0 4px!important;}',
    '#shopify-pc__banner .shopify-pc__banner__body-policy-link,',
    '.shopify-pc__banner__body-policy-link,',
    '#shopify-pc__banner .shopify-pc__banner__btn-manage-prefs,',
    '.shopify-pc__banner__btn-manage-prefs{',
    'color:#8c0606!important;font-size:14px!important;font-weight:600!important;',
    'text-decoration:underline!important;opacity:1!important;visibility:visible!important;',
    'pointer-events:auto!important;cursor:pointer!important;',
    '}',
    '#shopify-pc__banner .shopify-pc__banner__btns,',
    '.shopify-pc__banner__btns,',
    '#shopify-pc__banner .shopify-pc__banner__btns-granular,',
    '.shopify-pc__banner__btns-granular{',
    'display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:center!important;',
    'justify-content:flex-end!important;gap:8px!important;margin:0 0 0 auto!important;',
    'flex:0 0 auto!important;width:auto!important;pointer-events:auto!important;',
    '}',
    '#shopify-pc__banner .shopify-pc__banner__btns button,',
    '.shopify-pc__banner__btns button,',
    '#shopify-pc__banner #shopify-pc__banner__btn-accept,',
    '#shopify-pc__banner #shopify-pc__banner__btn-decline,',
    '#shopify-pc__banner .shopify-pc__banner__btn-accept,',
    '#shopify-pc__banner .shopify-pc__banner__btn-decline{',
    'display:inline-flex!important;align-items:center!important;justify-content:center!important;',
    'min-height:40px!important;height:40px!important;padding:0 14px!important;margin:0!important;',
    'font-size:14px!important;font-weight:600!important;border-radius:4px!important;',
    'cursor:pointer!important;pointer-events:auto!important;opacity:1!important;visibility:visible!important;',
    'white-space:nowrap!important;box-sizing:border-box!important;',
    '}',
    '#shopify-pc__banner #shopify-pc__banner__btn-decline,',
    '#shopify-pc__banner .shopify-pc__banner__btn-decline{',
    'background:#ffffff!important;color:#111111!important;border:1.5px solid #111111!important;',
    '}',
    '#shopify-pc__banner #shopify-pc__banner__btn-accept,',
    '#shopify-pc__banner .shopify-pc__banner__btn-accept{',
    'background:#111111!important;color:#ffffff!important;border:1.5px solid #111111!important;',
    '}',
    '@media (max-width:749px){',
    '#shopify-pc__banner .shopify-pc__banner__wrapper{flex-wrap:wrap!important;}',
    '#shopify-pc__banner .shopify-pc__banner__btns{width:100%!important;margin-left:0!important;}',
    '#shopify-pc__banner .shopify-pc__banner__btns button{flex:1 1 auto!important;}',
    '}',
    '[id*="jotform" i],[class*="jotform" i],iframe[src*="jotform"],#ShopifyChat,.shopify-chat,#dummy-chat-button-iframe{z-index:100020!important;}',
    '[id*="qikify" i],[class*="qikify" i],[class*="sales-pop" i],[class*="sales_pop" i],[id*="SalesPop" i],[class*="SalesPop" i]{',
    'z-index:100030!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;',
    '}'
  ].join('');

  function ensureStyle() {
    var el = document.getElementById(STYLE_ID);
    if (!el) {
      el = document.createElement('style');
      el.id = STYLE_ID;
      (document.head || document.documentElement).appendChild(el);
    }
    el.textContent = CSS;
  }

  function force(el, props) {
    if (!el || !el.style) return;
    Object.keys(props).forEach(function (k) {
      el.style.setProperty(k, props[k], 'important');
    });
  }

  function fixBanner(banner) {
    force(banner, {
      position: 'fixed',
      top: 'auto',
      left: '0px',
      right: '0px',
      bottom: '0px',
      width: '100%',
      height: 'auto',
      'max-height': 'none',
      overflow: 'visible',
      transform: 'none',
      'z-index': '99990',
      background: '#ffffff',
      'background-color': '#ffffff',
      color: '#111111',
      opacity: '1',
      'pointer-events': 'auto'
    });

    var dialog = banner.querySelector('.shopify-pc__banner__dialog');
    if (dialog) {
      force(dialog, {
        position: 'relative',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        height: 'auto',
        'max-height': 'none',
        overflow: 'visible',
        transform: 'none',
        background: '#ffffff',
        'background-color': '#ffffff',
        color: '#111111',
        opacity: '1'
      });
    }

    var wrapper = banner.querySelector('.shopify-pc__banner__wrapper');
    if (wrapper) {
      force(wrapper, {
        display: 'flex',
        'flex-direction': 'row',
        'align-items': 'center',
        'justify-content': 'space-between',
        height: 'auto',
        'max-height': 'none',
        overflow: 'visible',
        background: '#ffffff',
        color: '#111111',
        opacity: '1'
      });
    }

    var body = banner.querySelector('.shopify-pc__banner__body');
    if (body) {
      force(body, {
        color: '#111111',
        opacity: '1',
        visibility: 'visible',
        overflow: 'visible',
        'max-height': 'none',
        display: 'block'
      });
      body.querySelectorAll('*').forEach(function (n) {
        force(n, {
          color: n.tagName === 'A' || n.classList.contains('shopify-pc__banner__btn-manage-prefs') ? '#8c0606' : '#111111',
          opacity: '1',
          visibility: 'visible',
          overflow: 'visible',
          'max-height': 'none'
        });
      });
    }

    var btns = banner.querySelector('.shopify-pc__banner__btns, .shopify-pc__banner__btns-granular');
    if (btns) {
      force(btns, {
        display: 'flex',
        'flex-direction': 'row',
        'justify-content': 'flex-end',
        'margin-left': 'auto',
        'pointer-events': 'auto'
      });
    }

    banner.querySelectorAll('button, a').forEach(function (n) {
      force(n, { 'pointer-events': 'auto', cursor: 'pointer', opacity: '1', visibility: 'visible' });
    });
  }

  function liftOverlays() {
    document
      .querySelectorAll(
        '[id*="jotform" i], [class*="jotform" i], iframe[src*="jotform"], #ShopifyChat, .shopify-chat, #dummy-chat-button-iframe'
      )
      .forEach(function (el) {
        force(el, { 'z-index': '100020' });
      });
    document
      .querySelectorAll(
        '[id*="qikify" i], [class*="qikify" i], [class*="sales-pop" i], [class*="sales_pop" i], [id*="SalesPop" i], [class*="SalesPop" i]'
      )
      .forEach(function (el) {
        force(el, { 'z-index': '100030', visibility: 'visible', opacity: '1', 'pointer-events': 'auto' });
        if (el.style.display === 'none') el.style.removeProperty('display');
      });
  }

  function run() {
    ensureStyle();
    liftOverlays();
    document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner').forEach(fixBanner);
  }

  ensureStyle();
  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  [300, 800, 1600, 3000].forEach(function (ms) {
    setTimeout(run, ms);
  });
})();
